module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg",
    class: {
      'is-loading': _vm.isLoading
    },
    style: (_vm.imageBG)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db1d29f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/auth/components/ImageBg.vue
// module id = 863
// module chunks = 2